import React, { Component, Fragment } from 'react';
import config from '../config';
import List from "../components/Table/List";
import HeaderContent from "../components/HeaderContent";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Divider, Form } from "semantic-ui-react";
import Dialog from '../components/UI/Dialog';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { displayErrors } from '../helper';

class CustomerCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isUpdateDialog: false,
            isDeleteDialog: false,
            loading: false,
            id: '',
            name: '',
            description: ''
        }

        this.callbackFunction = this.callbackFunction.bind(this);
        this.createCategoryHandler = this.createCategoryHandler.bind(this);
        this.createNewCategoryHandler = this.createNewCategoryHandler.bind(this);
        this.updateCategoryHandler = this.updateCategoryHandler.bind(this);
        this.deleteCategoryHandler = this.deleteCategoryHandler.bind(this);
    };

    callbackFunction(childData, identifier) {
        this.setState({ id: childData.id });
        this.setState({ name: childData.name });
        this.setState({ description: childData.description });

        if (identifier === 'update') {
            this.setState({ isUpdateDialog: true });
        } else if (identifier === 'delete') {
            this.setState({ isDeleteDialog: true });
        }
    };

    createCategoryHandler() {
        this.setState({ open: true });
    };

    createNewCategoryHandler(values) {
        const { name, description } = values;

        this.setState({ loading: true });
        fetch(`${config.adminBaseURL}/category/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                "name": name,
                "description": description
            })
        }).then(res => {
            return res.json();
        }).then(data => {
            this.setState({ loading: false });
            if (data.success) {
                this.setState({ open: false });
                this.setState({ name: '' });
                this.setState({ description: '' });
                toast.success('Category created successfully!');
                this.refreshChild();
            } else {
                displayErrors(data, toast);
            }
        })
    };


    updateCategoryHandler(values) {
        const { id } = this.state;
        const { name, description } = values;

        this.setState({ loading: true });
        fetch(`${config.adminBaseURL}/category/update`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                "id": id,
                "name": name,
                "description": description
            })
        }).then(res => {
            return res.json();
        }).then(data => {
            this.setState({ loading: false });
            if (data.success) {
                this.setState({ isUpdateDialog: false });
                this.setState({ id: '' });
                this.setState({ name: '' });
                this.setState({ description: '' });
                toast.success('Category updated successfully!');
                this.refreshChild();
            } else {
                displayErrors(data, toast);
            }
        })
    };


    deleteCategoryHandler() {
        this.setState({ loading: true });
        fetch(`${config.adminBaseURL}/category/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                "id": this.state.id
            })
        }).then(res => {
            return res.json();
        }).then(data => {
            this.setState({ loading: false });
            if (data.success) {
                this.setState({ isDeleteDialog: false });
                this.setState({ id: '' });
                this.setState({ name: '' });
                this.setState({ description: '' });
                toast.success('Category deleted successfully!');
                this.refreshChild();
            } else {
                if(data.messages[0].text){
                    toast.error(data.messages[0].text);
                }else{
                    toast.error(data.description);
                }
            }
        })
    };

    render() {
        const { name, description, loading, open, isUpdateDialog, isDeleteDialog } = this.state;

        return (
            <Fragment>
                <HeaderContent onClickHandler={this.createCategoryHandler} buttonTitle={'Create New Category'} showButton={true} />
                <Divider />
                <List setRefresh={refresh => this.refreshChild = refresh} parentCallback={this.callbackFunction} />

                <Formik
                    initialValues={{ name: name, description: description }}
                    onSubmit={(values, { resetForm }) => {
                        this.createNewCategoryHandler(values);
                        resetForm();
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string()
                            .required('This field is required.'),
                        description: Yup.string()
                            .required('This field is required.')
                            .min(5, 'The length of description must be at least 5 characters')
                    })}
                >
                    {({ handleChange, handleBlur, errors, touched, values, handleSubmit }) => (
                        <Dialog
                            open={open}
                            onCancel={() => {
                                this.setState({ open: false })
                            }}
                            onConfirm={handleSubmit}
                            title={'Create New Category'}
                            confirmText={'Create Category'}
                            loading={loading}
                        >
                            <Form>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Form.Input fluid label="Name" type='text' name='name' placeholder='Name' value={values.name} onChange={handleChange} onBlur={handleBlur} />
                                        {errors.name && touched.name ? (
                                            <span className='formik-error-msg'>{errors.name}</span>
                                        ) : null}
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Form.Input fluid label="Description" type='text' name='description' placeholder='Description' value={values.description} onChange={handleChange} onBlur={handleBlur} />
                                        {errors.description && touched.description ? (
                                            <span className='formik-error-msg'>{errors.description}</span>
                                        ) : null}
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Dialog>
                    )}
                </Formik>

                <Formik
                    enableReinitialize
                    initialValues={{ name: name, description: description }}
                    onSubmit={values => {
                        this.updateCategoryHandler(values);
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string()
                            .required('This field is required.'),
                        description: Yup.string()
                            .required('This field is required.')
                            .min(5, 'The length of description must be at least 5 characters')
                    })}
                >
                    {({ handleChange, handleBlur, errors, touched, values, handleSubmit }) => (
                        <Dialog
                            open={isUpdateDialog}
                            onCancel={() => {
                                this.setState({ isUpdateDialog: false });
                                this.setState({ id: '' });
                                this.setState({ name: '' });
                                this.setState({ description: '' });
                            }}
                            onConfirm={handleSubmit}
                            title={'Update Category'}
                            confirmText={'Update Category'}
                            loading={loading}
                        >
                            <Form>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Form.Input fluid label="Name" type='text' name='name' placeholder='Name' value={values.name} onChange={handleChange} onBlur={handleBlur} />
                                        {errors.name && touched.name ? (
                                            <span className='formik-error-msg'>{errors.name}</span>
                                        ) : null}
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Form.Input fluid label="Description" type='text' name='description' placeholder='Description' value={values.description} onChange={handleChange} onBlur={handleBlur} />
                                        {errors.description && touched.description ? (
                                            <span className='formik-error-msg'>{errors.description}</span>
                                        ) : null}
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Dialog>
                    )}
                </Formik>

                <Dialog
                    open={isDeleteDialog}
                    onCancel={() => {
                        this.setState({ isDeleteDialog: false });
                        this.setState({ id: '' });
                        this.setState({ name: '' });
                        this.setState({ description: '' });
                    }}
                    onConfirm={this.deleteCategoryHandler}
                    title={'Delete Category'}
                    confirmText={'Delete Category'}
                    loading={loading}
                ><p>Are you sure you want to delete this category?</p></Dialog>

                <ToastContainer />
            </Fragment>
        );
    }
};

export default CustomerCategory;